import { NetworkStatus } from '@apollo/client';

// Simple utility to check if a query should be considered as loading
const getIsLoadingQuery = (networkStatus: NetworkStatus, data: unknown) =>
  (networkStatus === NetworkStatus.loading && !data) ||
  networkStatus === NetworkStatus.refetch;

export { getIsLoadingQuery };
